export class Sincronizador {
  private fila = Promise.resolve();

  async sync<T>(callback: () => Promise<T>): Promise<T> {
    const promise = this.fila.then(() => callback());

    this.fila = promise.then(() => {}).catch(() => {});

    return promise;
  }
}
